/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerProfileDtoModel, CustomerProfileDtoModelType } from "./CustomerProfileDtoModel"
import { CustomerProfileDtoModelSelector } from "./CustomerProfileDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  customer: CustomerProfileDtoModelType;
}

/**
 * CreatedCustomerWithOrderDtoBase
 * auto generated base class for the model CreatedCustomerWithOrderDtoModel.
 */
export const CreatedCustomerWithOrderDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('CreatedCustomerWithOrderDto')
  .props({
    __typename: types.optional(types.literal("CreatedCustomerWithOrderDto"), "CreatedCustomerWithOrderDto"),
    orderUuid: types.identifier,
    customer: types.union(types.undefined, MSTGQLRef(types.late((): any => CustomerProfileDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class CreatedCustomerWithOrderDtoModelSelector extends QueryBuilder {
  get orderUuid() { return this.__attr(`orderUuid`) }
  customer(builder: string | CustomerProfileDtoModelSelector | ((selector: CustomerProfileDtoModelSelector) => CustomerProfileDtoModelSelector) | undefined) { return this.__child(`customer`, CustomerProfileDtoModelSelector, builder) }
}
export function selectFromCreatedCustomerWithOrderDto() {
  return new CreatedCustomerWithOrderDtoModelSelector()
}

export const createdCustomerWithOrderDtoModelPrimitives = selectFromCreatedCustomerWithOrderDto().orderUuid
